import {Centre} from "../styled/Center.styled";

function Membership(props) {
  return <Centre>
      <h1>Membership</h1>
      <p>To be added soon!!!</p>
  </Centre>;
}

export default Membership;
